/*
 * @Description: 应用入口
 */
import { createApp } from 'vue'

import App from './App.vue'

import '@/assets/less/index.less'

import router from '@router/index'

const app = createApp(App)
app.use(router).mount(`#app`)

app.config.errorHandler = (err, instance, info) => {
  // 可在此统一处理错误
}

app.config.warnHandler = (msg, instance, trace) => {
  // 可在此统一处理警告
}
